import { render, staticRenderFns } from "./TransferPatterns.vue?vue&type=template&id=bd4649a2"
import script from "./TransferPatterns.vue?vue&type=script&lang=js"
export * from "./TransferPatterns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports